export default __webpack_public_path__ + "static/media/btn_step_4_default.9288a677.svg";